import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

interface ChannelCardProps {
  to: string;
  type: string;
  title: string;
  description: string;
  logoSrc: string;
  index: number;
  videoHeader?: boolean;
  imageHeader?: boolean;
  srcVideo?: string;
  srcImage?: string;
}

const ChannelCard: React.FC<ChannelCardProps> = ({
  to,
  type,
  title,
  description,
  logoSrc,
  index,
  srcVideo = '',
  srcImage = '',
  videoHeader = false,
  imageHeader = false
}) => {
  const lightVideoRef = useRef<HTMLVideoElement>(null);
  const darkVideoRef = useRef<HTMLVideoElement>(null);

  const handleMouseEnter = () => {
    lightVideoRef.current?.play();
    darkVideoRef.current?.play();
  };

  const handleMouseLeave = () => {
    lightVideoRef.current?.pause();
    darkVideoRef.current?.pause();
  };

  return (
    <div
      className={`col-lg-4 animate-fadeInUp animate-delay-${index} p-7`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Link to={to}>
        <div className="card hover-scale card-hover-n cursor-pointer border-0 rounded-4">
          {videoHeader && (
            <>
              <div className="cardPannel__hero theme-light-show">
                <video
                  ref={lightVideoRef}
                  className="cardPannel__hero-video"
                  loop
                  muted
                  playsInline
                  src={`/assets/media/videos/${srcVideo}.mp4`}
                />
              </div>
              <div className="cardPannel__hero theme-dark-show">
                <video
                  ref={darkVideoRef}
                  className="cardPannel__hero-video"
                  loop
                  muted
                  playsInline
                  src={`/assets/media/videos/${srcVideo}-dark.mp4`}
                />
              </div>
            </>
          )}
          {imageHeader && (
            <>
              <div className="cardPannel__hero theme-light-show">
                <img
                  alt="imageCh"
                  title="image-header-card"
                  className="cardPannel__hero-image"
                  src={`/assets/media/img/${srcImage}.png`}
                />
              </div>
              <div className="cardPannel__hero theme-dark-show">
                <img
                  alt="imageCh"
                  title="image-header-card"
                  className="cardPannel__hero-image"
                  src={`/assets/media/img/${srcImage}-dark.png`}
                />
              </div>
            </>
          )}
          <div className="card-body">
            <div className="row align-items-center">
              <div className="col-7 ps-xl-20">
                <div className="mb-6 pt-6 extend-card">
                  <span className="fs-4 fw-semibold me-2 d-block lh-1 opacity-75">{type}</span>
                  <span className="fs-1 fw-bold ">{title}</span>
                </div>
              </div>
              <div className="col-5 mb-5">
                <div className="bgi-no-repeat bgi-size-contain bgi-position-x-end h-220px ms-10">
                  <img alt="imageCh" src={logoSrc} width={'80px'} className="hover-scale" />
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <div className="d-flex justify-content-center mb-6">
              <span className="text-center mw-1000px">{description}</span>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ChannelCard;
